<ng-container *ngIf="configuration$ | async as configuration">
  <ng-container *ngIf="configuration.groups.length > 1">
    <button
      class="btn btn-block btn-secondary cx-previous"
      [disabled]="isFirstGroup(configuration.owner) | async"
      (click)="onPrevious(configuration)"
      [attr.aria-label]="'configurator.a11y.previous' | cxTranslate"
    >
      {{ 'configurator.button.previous' | cxTranslate }}
    </button>
    <button
      class="btn btn-block btn-secondary cx-next"
      [disabled]="isLastGroup(configuration.owner) | async"
      (click)="onNext(configuration)"
      [attr.aria-label]="'configurator.a11y.next' | cxTranslate"
    >
      {{ 'configurator.button.next' | cxTranslate }}
    </button>
  </ng-container>
</ng-container>
